<template>
    <section class="slider" :aria-label="data.heading">
      <button id="autoplay" aria-pressed="false">
            <span class="sr-only">Pause</span>
      </button>
      <ul>
      <li v-for="(slide, index) in data.slides" :key="index" class="slider-img-container" v-bind:class="slide.className" tabindex="-1">
        <div class="slider-text-container">
            <div class="slider-text" v-html="slide.htmlContent">
            </div>
        </div>
      </li>
      </ul>

      <ul class="slidenav">
        <li v-for="(slide, index) in data.slides" :key="index"> 
          <button v-bind:class="{ current: (index == 0) }" :data-slide="index">
            <span class="sr-only">Element {{index*1 + 1}}</span>
            <span v-if="(index == 0)" class="sr-only" id="current">(aktuell angezeigt)</span>
          </button>
        </li>
      </ul>
    </section>
</template>

<script>
import sliderHelper from '../../shared/sliderHelper';

export default {
  name: "Slider",
  props: ['data'],
  created() { 
      this.initSlider = sliderHelper.init; // now you can call this.foo() (in your functions/template)
      this.exitSlider = sliderHelper.destroy; // now you can call this.foo() (in your functions/template)
   },
  mounted () {
      this.initSlider();  
  },
  beforeDestroy(){
      this.exitSlider();  
  }
}
</script>


// WEBPACK FOOTER //
// src/components/shared/Slider.vue